import type { ResultAsync } from 'neverthrow';
import contentApiClient from './contentApiClient';
import { responseWithErrorHandler } from '.';
import type { CouponLookupResponse } from '@/models/CouponLookupResponse';

export const lookupCouponCode = (couponCode: string): ResultAsync<CouponLookupResponse, Error> => {
	const data = contentApiClient.client
		.get(`Coupon/${couponCode}`)
		.json<CouponLookupResponse>();

	return responseWithErrorHandler(data);
};
